/*
 * @Author: Zhouqi
 * @Date: 2025-11-08 15:27:00
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-04-20 14:50:27
 */
import { UploadFile } from 'antd/es/upload';

// 导出校验相关类型
export * from './validator';

import { FileUploadRule } from './validator';

/**
 * 扩展的上传文件类型,包含上传进度
 */
export interface ExtendedUploadFile extends UploadFile {
  /** 上传进度 0-100 */
  uploadProgress?: number;
  /** 预览图地址，图片通常等于 url，视频通常是首帧封面 */
  previewUrl?: string;
  /** 是否被选中（用于多图选择场景） */
  isSelected?: boolean;
  /** 错误信息（上传失败时的错误描述） */
  errorMessage?: string;
  /**
   * 媒体时长（单位：秒）
   * - 仅视频和音频文件有效
   * - 在上传成功后自动提取
   * - 提取失败时为 undefined
   * - onChange 回调触发时已包含此值
   */
  duration?: number;
}

/**
 * 通用上传组件 Props
 */
export interface BaseUploadProps {
  children?: React.ReactNode;
  maxCount?: number;
  fileList?: ExtendedUploadFile[];
  onChange?: (fileList: ExtendedUploadFile[], file: ExtendedUploadFile) => void;
  disabled?: boolean;
  accept?: string;
  /** 文件校验规则 */
  rules?: FileUploadRule[];
  /** 校验失败回调（统一使用 string，不再使用 string[] ） */
  onValidationFailed?: (error: string) => void;
}

/**
 * 上传进度回调参数
 */
export interface UploadProgressData {
  progress: number;
  status: boolean;
  url: string;
}
